import React, { Component } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { observer , inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import './Debug.css'
import { withRouter } from 'react-router-dom';
 

class Debug extends Component {
    state = {
        top: false,
        left: false,
        bottom: false,
        right: false,
        url: ''
    };
    toggleDrawer = (side, open) => () => {
        this.setState({
          [side]: open,
        });
    };

    showCreatePrivacyModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.setSection('create_privacy')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }
    showIframeModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.setSection('iframe')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }
    showCreateTermsModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.DGRModalStore.setSection('create_terms')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }

    componentWillUpdate ({ location, history }) {
        if (location.pathname === this.props.location.pathname) {
            return;
        }
        this.setState({
            'url': location.pathname,
        });
    }

    render(){
        const {  debugMode } = this.props.DGRStore
        const visibility = () => {
            if (debugMode){
                return {
                    display:'block'
                }
            }else{
                return {
                    display:'none'
                }
            
            }
        }
        return(
            <div className="debugLinks" style={visibility()} > 
		        <button onClick={this.toggleDrawer('left', true)}>Links</button>
                <input
                id="outlined-bare"
                className="debugText"
                margin="normal"
                value={this.state.url}
                readOnly={true}
                variant="outlined"
                />
                <SwipeableDrawer
                    open={this.state.left}
                    onClose={this.toggleDrawer('left', false)}
                    onOpen={this.toggleDrawer('left', true)}
                >
                    <Link to="/enter_pass">Enter Pass</Link>
                    <Link to="/create_pass">Create Pass</Link>
                    <Link to="/join">Join</Link>
                    <Link to="/membership_options">Membership Options</Link>
                    <Link to="/expired">Expired</Link>
                    <Link to="/sign_waiver">Sign Waiver</Link>
                    <Link to="/first_visit">First Visit</Link>
                    <Link to="/enjoy_visit">Enjoy Visit</Link>
                    <Link to="/enjoy_tour">Enjoy Tour</Link>
                    <Link to="/return_visit">Return Visit</Link>
                    <Link to="/guardian">Guardian</Link>
                    <Link to="/under_18">Under 18</Link>
                    <Link to="/lead">Lead</Link>
                    <Link to="/test">Test</Link>
                    <Link to="/test2">Test2</Link>
                    <Link to="/test3">Test3</Link>
                    <Link to="/test3">Test3</Link>
                    <button
                        className="showIframeModalButton"
                        onClick={this.showIframeModal}
                    >IframeModal</button>
                    <button
                        onClick={this.showCreateTermsModal}
                    >CreateTerms</button>
                    <button
                        onClick={this.showCreatePrivacyModal}
                    >CreatePrivacy</button>
                </SwipeableDrawer>
            </div>
        )
    }
}


Debug = inject('DGRStore','DGRModalStore')(observer(Debug))     
export default withRouter(Debug);



// WEBPACK FOOTER //
// ./src/components/DGR/Debug/Debug.js